import { forwardRef } from "react";

type Props = {
  disabled?: boolean;
  onPickFile: (file: File) => void;
};

export const BoardPdfButton = forwardRef<HTMLInputElement, Props>(function BoardPdfButton(
  { disabled, onPickFile },
  ref
) {
  function onChange(ev: React.ChangeEvent<HTMLInputElement>) {
    const file = ev.target.files?.[0];
    ev.target.value = "";
    if (file) onPickFile(file);
  }

  return (
    <label
      className={`wb-tool-icon-btn wb-tool-icon-btn--ghost${disabled ? " is-disabled" : ""}`}
      title="Презентация / PDF (Ctrl+Shift+P)"
      aria-label="Добавить презентацию"
    >
      <input
        ref={ref}
        type="file"
        accept="application/pdf,.pdf,.pptx,.ppt,application/vnd.openxmlformats-officedocument.presentationml.presentation,application/vnd.ms-powerpoint"
        hidden
        disabled={disabled}
        onChange={onChange}
      />
      <svg
        className="wb-tool-icon-btn__svg"
        width="22"
        height="22"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden
      >
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
        <polyline points="14 2 14 8 20 8" />
        <path d="M10 12h4" />
        <path d="M10 16h4" />
      </svg>
    </label>
  );
});
